
const WyomingUsage = ([jan, feb, mar, apr, ma, jun, jul, aug, sep, oct, nov, dec], usageAnnual, usageType) => {

  // const average = (arr) => arr.reduce((a, b) => a + b) / arr.length
  const total = (arr) => arr.reduce((a, b) => a + b)

  let janBase = 824
  let febBase = 670
  let marBase = 652
  let aprBase = 595
  let mayBase = 604
  let junBase = 819
  let julBase = 1090
  let augBase = 1010
  let septBase = 764
  let octBase = 645
  let novBase = 644
  let decBase = 824

  let base = [janBase, febBase, marBase, aprBase, mayBase, junBase, julBase, augBase, septBase, octBase, novBase, decBase]

  let baseTotal = total(base)

  const calc = (num1, num2) => {
    if (num1) {
      return num2
    } return 0
  }

  let january = calc(jan, janBase)
  let february = calc(feb, febBase)
  let march = calc(mar, marBase)
  let april = calc(apr, aprBase)
  let may = calc(ma, mayBase)
  let june = calc(jun, junBase)
  let july = calc(jul, julBase)
  let august = calc(aug, augBase)
  let september = calc(sep, septBase)
  let october = calc(oct, octBase)
  let november = calc(nov, novBase)
  let december = calc(dec, decBase)

  const baseArray = [+january, +february, +march, +april, +may, +june, +july, +august, +september, +october, +november, +december]
  const usage = [+jan, +feb, +mar, +apr, +ma, +jun, +jul, +aug, +sep, +oct, +nov, +dec]

  let totalUsage = total(usage)
  let totalBase = total(baseArray)

  let ratio = totalBase / totalUsage

  const calc2 = (num1, num2) => {
    if (num1) {
      return num1
    } return Math.round(1 / ratio * num2)
  }

  let partial = 0

  if (usageType === 'Partial 12 Months') {
    partial = 1.2
  } else if (usageType === 'Full 12 Months') {
    partial = 1
  }

  let januaryTotal = Math.round(calc2(jan, janBase) * partial)
  let februaryTotal = Math.round(calc2(feb, febBase) * partial)
  let marchTotal = Math.round(calc2(mar, marBase) * partial)
  let aprilTotal = Math.round(calc2(apr, aprBase) * partial)
  let mayTotal = Math.round(calc2(ma, mayBase) * partial)
  let juneTotal = Math.round(calc2(jun, junBase) * partial)
  let julyTotal = Math.round(calc2(jul, julBase) * partial)
  let augustTotal = Math.round(calc2(aug, augBase) * partial)
  let septemberTotal = Math.round(calc2(sep, septBase) * partial)
  let octoberTotal = Math.round(calc2(oct, octBase) * partial)
  let novemberTotal = Math.round(calc2(nov, novBase) * partial)
  let decemberTotal = Math.round(calc2(dec, decBase) * partial)

  let totalArray = [+januaryTotal, +februaryTotal, +marchTotal, +aprilTotal, +mayTotal, +juneTotal, +julyTotal, +augustTotal, +septemberTotal, +octoberTotal, +novemberTotal, +decemberTotal]

  //TO FIND THE MONTHLY USAGE IF ONLY GIVEN ANNUAL USAGE FROM SALES REP
  const calc3 = (num1, num2) => {
    return Math.round((num1 / baseTotal) * num2)
  }

  let janAnn = calc3(janBase, usageAnnual)
  let febAnn = calc3(febBase, usageAnnual)
  let marAnn = calc3(marBase, usageAnnual)
  let aprAnn = calc3(aprBase, usageAnnual)
  let mayAnn = calc3(mayBase, usageAnnual)
  let junAnn = calc3(junBase, usageAnnual)
  let julAnn = calc3(julBase, usageAnnual)
  let augAnn = calc3(augBase, usageAnnual)
  let septAnn = calc3(septBase, usageAnnual)
  let octAnn = calc3(octBase, usageAnnual)
  let novAnn = calc3(novBase, usageAnnual)
  let decAnn = calc3(decBase, usageAnnual)

  let annualArray = [janAnn, febAnn, marAnn, aprAnn, mayAnn, junAnn, julAnn, augAnn, septAnn, octAnn, novAnn, decAnn]

  let annualUsage = total(annualArray)


  // let sum = baseArray.map(function(num, i){
  //   return num + totalArray[i]
  // })

  // console.log(totalArray, sum)


  if (usageAnnual) {
    return annualArray
  }
  return totalArray
}

export default WyomingUsage